import { IReference } from '../../../../../expressions/references/IReference';
import { IAssignableExpression } from '../../../../../expressions/repository/assignable/IAssignableExpression';
import { IAsyncServiceParameter } from '../../../../../expressions/repository/async/context/IAsyncService';

export enum ButtonActionType {
  ListAdd = 'listAdd',
  ListRemove = 'listRemove',
  ExecAsyncService = 'execAsyncService',
  SubsectionOpen = 'openSubsection',
}

export type IButtonAction =
  | IButtonActionListAdd
  | IButtonActionListRemove
  | IButtonActionExecAsyncService
  | IButtonActionSubsectionOpen;

export interface IBaseButtonAction {
  type: ButtonActionType;
}

export interface IButtonActionListAdd extends IBaseButtonAction {
  type: ButtonActionType.ListAdd;
  /**
   * Reference al Widget Ripetibile
   */
  listReference: IReference;
}

export interface IButtonActionListRemove extends IBaseButtonAction {
  type: ButtonActionType.ListRemove;
  /**
   * Reference al Widget Ripetibile
   */
  listReference: IReference;
}

export interface IButtonActionExecAsyncService extends IBaseButtonAction {
  type: ButtonActionType.ExecAsyncService;
  /**
   * ID del servizio asincrono da eseguire
   * @see IAsyncService
   */
  serviceId: string;
  inputs: Record<string, IAssignableExpression>;
  outputs?: IAsyncServiceParameter[];

  enableRequestMessage?: boolean | null;
  requestMessage?: string | null;
  enableSuccessMessage?: boolean | null;
  successMessage?: string | null;
}

export function isButtonActionExecAsyncService(
  action: IButtonAction,
): action is IButtonActionExecAsyncService {
  return action.type === ButtonActionType.ExecAsyncService;
}

export interface IButtonActionSubsectionOpen extends IBaseButtonAction {
  type: ButtonActionType.SubsectionOpen;
  /**
   * Widget Sottosezione da aprire
   */
  subsectionReference: IReference;
}
